
import { nextTick } from 'vue'
import { Component, Mixins } from 'vue-property-decorator'

@Component({
  components: { },
})
export default class VideoModal extends Mixins() {
  close () {
    const $videoWrapper = document.getElementById('video-player-wrapper')
    const $video = document.getElementById('video-player')

    if (!$videoWrapper || !$video) {
      return
    }

    $videoWrapper.appendChild($video)

    nextTick(() => {
      this.$emit('close')
    })
  }

  mounted() {
    const $video = document.getElementById('video-player')
    const $modal = document.getElementById('video-modal')

    if (!$video || !$modal) {
      return
    }

    $modal.appendChild($video)
  }
}
